<!--首页-->
<template>
	<div>
		<div class="box">


			<div class="more-box" v-show="row.doing.length>0">
				<div class="more-active">
					<div style="display:flex;align-items: center">
						<div class="solid solid2"></div>
						<span class="more-title">正在报名
						</span>
					</div>
					<!--<div style="display:flex;align-items: center">-->
						<!--<div class="more-right">更多</div>-->
						<!--<img src="../../../assets/images/arrow.png" alt="" srcset="">-->
					<!--</div>-->
				</div>
				<div style="display:flex;justify-content: space-between; display: none" >
					<div class="more-items"  >
						<img src="../../../assets/images/pic-homepage-Meetings-and-training1.png" alt="" srcset="">
						<span>首次注册</span>
					</div>
					<div class="more-items"  >
						<img src="../../../assets/images/pic-homepage-Meetings-and-training2.png" alt="" srcset="">
						<span>报名申请</span>
					</div>
					<div class="more-items"  >
						<img src="../../../assets/images/pic-homepage-Meetings-and-training3.png" alt="" srcset="">
						<span>咨询查询</span>
					</div>
				</div>

				<div class="main-solid"></div>
				<div class="train-box flex-between" style="flex-wrap: wrap;">

					<div class="train-items" v-for="(row,index) in row.doing" v-rblink="{name:'HuiyiApplyFormStep1',query:{saiqu_id:row.id}}">
						<div class="train-items-top items-top1"
						:style="'background-image: linear-gradient(to right, #'+row.color[0]+' , #'+row.color[1]+');'"
						>
							<div>
								<div class="train-items-top-city">{{row.location}}</div>
								<div class="train-items-top-time">{{row.date_str}}</div>
							</div>
							<div class="train-sing-up-btn">报名</div>
						</div>
						<div class="train-items-title">{{row.name}}</div>
						<div class="flex-between">
							<div class="train-items-time">{{row.startdate}}</div>
							<div class="train-items-address">{{row.province}}·{{row.city}}</div>
						</div>
					</div>


				</div>
			</div>

			<LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
		</div>

	</div>
</template>
<style scoped>
	/* @import '../../assets/style/index.css'; */


	.row4{
		/*display: flex;*/
		/*align-items: center;*/
		/*justify-content: space-between;*/
		margin: 10px 10px;
		/*flex-wrap: wrap;*/
	}
	.row4 img{
		width: 100%;
		float: left;
		width: calc(25% - 10px);
		margin: 0 10px 10px 0;
	}
	.more-box{
		width: 6.25rem;
		background: #fff;
		margin:20px auto;
		border-radius: 10px;
		overflow: hidden;
		padding: 20px;
	}
	.more-active{
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}
	.solid1{background-image: linear-gradient( #1EB2FF , #2B7AFF);}
	.solid2{background-image: linear-gradient( #FFC934 , #FF9C00);}
	.solid3{background-image: linear-gradient( #FF7D6F , #FF433E);}
	.solid4{background-image: linear-gradient( #E77EFF , #8B5AFD);}
	.solid5{background-image: linear-gradient( #FFC934 , #FF9C00);}
	.solid6{background-image: linear-gradient( #1EB2FF , #2B7AFF);}
	.solid7{background-image: linear-gradient( #FF7D6F , #FF4540);}



	.more-items{width: 2.02rem;position: relative;display: flex;align-items: center;}
	.more-items img{width: 2.02rem;}
	.more-items span{font-size:14px;
		font-family:'PingFangSC-Regular,PingFang SC';
		font-weight:400;
		color:rgba(255,255,255,1);
		position: absolute;left: 7px;}

	.more-active .solid{width: 4px;height: 25px;border-radius: 4px;margin-right: 5px;}
	.more-active .more-title{color:#333;font-size:16px; height: 25px;line-height: 25px;}
	.more-active .more-right{color:#333;font-size:14px; height: 25px;line-height: 25px;}
	.more-active img{margin-left: 5px;width: 5.5px;height: 10px;}
	.main-solid{width:100%;height:1px;background-color:#f8f8f8;margin:10px 0}
	.flex-between{display:flex;justify-content: space-between;}
	.fontFamily{font-family:'PingFangSC-Regular,PingFang SC';}


	.train-items{width: 3.08rem; margin-bottom: 0.3rem}

	.items-top1{background-image: linear-gradient(to right, #01EA9B , #8DEC9D);}
	.items-top2{background-image: linear-gradient(to right, #2B7AFF , #1EB2FF);}

	.train-items-top{width: 3.08rem;height: 1.68rem;border-radius: 10px;
		display: flex;align-items: center;justify-content: space-around;}
	.train-items-top-city{color:#fff; font-size:32px;font-weight:500; font-family:PingFangSC-Medium,PingFang SC  }
	.train-items-top-time{color:#fff; font-size:15px;font-weight:500; font-family:PingFangSC-Medium,PingFang SC  }
	.train-sing-up-btn{width: 48px;height: 26px;color:#fff;font-size:12px;font-weight:500;font-family:'PingFangSC-Medium,PingFang SC';
		border: 1px solid #fff;border-radius: 26px;text-align: center;line-height: 26px; }
	.train-items-title{color:#333;font-size:14px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC';margin: 5px 0; }
	.train-items-time,.train-items-address{color:#595757;font-size:12px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC'; }
	.train-items-address{margin-right: 10px;}


	.box {
		background: #F8F8F8;
		margin-bottom: 50px;
		overflow: hidden;
	}



</style>

<script>
	import Vue from 'vue';
	import TabBar from '@/components/TabBar.vue';
	import LoginDialog from '@/components/LoginDialog.vue';
	  
	export default {
		name: 'HuiyiIndex',
		components: {
			TabBar,LoginDialog
			 
		},
		data: function () {
			return {
				loginShow:false,
				showTabBar:false,
				 row:{
				 	doing:[],
					 going:[],
					 pass:[]
				 },
				catelist:[]

			}
		},
		filter: {},
		mounted() {
			document.title = '会议培训';
			 this.showTabBar = window.isApp()? false:true;
			let that = this;
			that.$api.get(
					"/api/cms/catelist",{
						parent_id:72
					},
					res => {
						that.catelist = res.data
					},
					res => {
						Toast(res.msg);
					}
			);

			 this.fetch()
		},
		destroyed() {
		},
		methods: {
			fetch(){
				let that = this;
				this.$api.get('/api/huiyi/indexData', {
					gametype:that.$route.query.gametype
				}, (res) => {
					console.log(res)
					that.row = res.data
				},(res) =>{
					console.log('没有登录');
					if (res.code == 401 || res.code==402) {
						if(window.isApp()){
							rbLink({
								name:'login','query':{ }
							},'replace');
							return false;
						}
						that.loginShow = true
					}else {
						Toast(res.msg)
					}
				})
			},

			loginSuccess(res){
				console.log('-------登录成功--------',res);
				this.loginShow = false;
				this.fetch();
			},

			loginCancel(){
				console.log('-------取消登录--------');
				// this.loginShow = false;
			},


		}
	}
</script>



// WEBPACK FOOTER //
// HuiyiList.vue?5107723d